import { createAction, props } from '@ngrx/store';

export interface DeeplinkParams {
  invoiceId: string;
  user: string;
  provet_env: string;
  provet_id: string;
  department_id: string;
  timestamp: string;
  verification: string;
}

export const ProcessProvetSendInvoice = createAction(
  '[Deeplink Handlers] Process Provet Send Invoice',
  props<{ params: DeeplinkParams }>()
);

export const ProcessProvetSendInvoiceSuccess = createAction(
  '[Deeplink Handlers] Process Provet Send Invoice Success',
  props<{ response: any }>()
);

export const ProcessProvetSendInvoiceFail = createAction(
  '[Deeplink Handlers] Process Provet Send Invoice Fail',
  props<{ error: string; errorCode?: number | null }>()
);